export enum ServiceInCartNotificationDataHooks {
  MAIN = 'service-in-cart-notification',
}
